<template>
  <div class="regulation-page mt-4">
    <app-page-header
      title="Regulamento"
      :subtitle="regulation.title"
    ></app-page-header>

    <div class="container">
      <div class="row">
        <div class="col-12 text-container">
          <div v-html="regulation.text"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import RegulationService from '@/services/regulation.service';

export default {
  name: 'regulation-page',
  data: () => {
    return {
      isLoading: true,
      regulation: {},
    };
  },
  methods: {
    load() {
      this.isLoading = true;

      RegulationService.get()
        .then(({ data: regulation }) => (this.regulation = regulation))
        .finally(() => (this.isLoading = false));
    },
  },
  mounted() {
    this.load();
  },
};
</script>

<style scoped>
.text-container >>> p {
  margin-bottom: 10px;
}
</style>
